import styled from '@emotion/styled';
import theme from '../../../themes/default';

export const Container = styled('div')`
  height: 304px;
  overflow-y: auto;
  flex-direction: column;
  align-items: center;
`;

const getYearColor = ({ selected, disabled }) => {
  if (disabled) {
    return theme.color.grey9;
  }
  if (selected) {
    return theme.color.purple3;
  }
  return 'inherit';
};

export const Year = styled('div', {
  shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'disabled',
})`
  display: flex;
  cursor: pointer;
  width: 100%;
  font-size: ${({ selected }) => (selected ? '24px' : '14px')};
  font-weight: ${({ selected }) => (selected ? '500' : 'normal')};
  height: 40px;
  justify-content: center;
  align-items: center;
  margin: ${({ selected }) => (selected ? '10px 0' : '0')};
  color: ${(props) => getYearColor(props)};
`;
